import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/sass/style.scss'
import '@/assets/sass/financier.scss'

// Highcharts
import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue) // <-- Install HighchartsVue

// ApexCharts
import VueApexCharts from 'vue-apexcharts'
// Note: If VueApexCharts is installed globally, it's often done like this:
Vue.use(VueApexCharts, {
    // optional config
})
import DataTables from 'vue-data-tables'

Vue.use(DataTables)


// AJOUT OBLIGATOIRE ! 🔥🔥🔥
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 🔥 Firebase
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

//Vue editor
import VueEditor from 'vue2-editor'

Vue.use(VueEditor)
// 🔧 Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// 🔧 Loading Overlay
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading, {
  isFullPage: false,
  canCancel: false,
  loader: 'spinner'
})

// 🔧 Element UI
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/fr'
import 'element-ui/lib/theme-chalk/index.css'
import 'material-icons/iconfont/material-icons.css';
Vue.use(ElementUI, { locale })


// 🔧 Vuesax
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax)

// 🔧 Excel Export
import excel from 'vue-excel-export'
Vue.use(excel)

// 🔧 Vue Moment
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
require('moment/locale/fr')
Vue.use(VueMoment, { moment })

// 🔧 HTML2Canvas
import VueHtml2Canvas from 'vue-html2canvas'
Vue.use(VueHtml2Canvas)

// 🔧 Custom inputs
import vueNumericCustom from '@/custominput/vueNumeric'
import datePickerCustom from '@/custominput/datePicker'
import fileUploadCustom from '@/custominput/fileUpload'
import elSelectCustom from '@/custominput/elSelect'
import elInputCustom from '@/custominput/elInput'

Vue.component('field-vueNumericCustom', vueNumericCustom)
Vue.component('field-datePickerCustom', datePickerCustom)
Vue.component('field-fileUploadCustom', fileUploadCustom)
Vue.component('field-elSelectCustom', elSelectCustom)
Vue.component('field-elInputCustom', elInputCustom)

import { NumberToLetter } from './numToLetter'

Vue.filter('toLetter', value => NumberToLetter(value))
Vue.filter('reduceParagraphLength', value => {
  if (!value || typeof value !== 'string') return ''
  const max = 100
  const txt = value.replace(/<\/?[^>]+(>|$)/g, '')
  return txt.length > max ? txt.slice(0, max) + '...' : value
})

// 🔥 Firebase config
const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

firebase.initializeApp(config)
firebase.firestore().settings({ cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED })

Vue.prototype.$firestore = firebase.firestore()
Vue.prototype.$firestorage = firebase.storage()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
